export const NAV = {
  home: "nav-home",
  collection: "nav-collection",
  house: "nav-house",
  journal: "nav-journal",
  contact: "nav-contact",
  logo: "nav-logo",
};

export const HERO = {
  section: "hero-section",
  cta: "hero-cta",
  scrollHint: "hero-scroll-hint",
};

export const COLLECTION = {
  list: "collection-list",
  item: (slug) => `collection-item-${slug}`,
  view: (slug) => `collection-view-${slug}`,
};

export const PRODUCT = {
  page: "product-page",
  enquireBtn: "product-enquire",
  enquireDialog: "product-enquire-dialog",
  enquireName: "enquire-name",
  enquireEmail: "enquire-email",
  enquireMessage: "enquire-message",
  enquireSubmit: "enquire-submit",
};

export const JOURNAL = {
  list: "journal-list",
  item: (slug) => `journal-item-${slug}`,
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  subject: "contact-subject",
  message: "contact-message",
  submit: "contact-submit",
};

export const WAITLIST = {
  input: "waitlist-input",
  submit: "waitlist-submit",
};

export const HOME = {
  emergentLink: "home-emergent",
};
